import { IForm } from 'core-components/classes/models/IForm'

export const getName = (item: IForm) => {
  const firstName = item.firstName || item.FirstName
  const lastName = item.lastName || item.LastName
  return `${firstName} ${lastName}`
}
